var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tagInfo" },
    [
      _c(
        "van-tabs",
        {
          attrs: { sticky: "", swipeable: "", "title-active-color": "red" },
          model: {
            value: _vm.tabActive,
            callback: function($$v) {
              _vm.tabActive = $$v
            },
            expression: "tabActive"
          }
        },
        _vm._l(_vm.tab, function(tabItem, index) {
          return _c(
            "van-tab",
            { key: tabItem.index, attrs: { title: tabItem.name } },
            [
              _vm.tabActive == 0
                ? _c("div", { staticClass: "information-flex" }, [
                    _c("ul", { staticClass: "lists" }, [
                      _c("li", [
                        _c("div", { staticClass: "lists-item" }, [
                          _vm._v("入会时间")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "lists-text" }, [
                          _vm._v(_vm._s(_vm.clientInfo.baseInfo.registerDate))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("div", { staticClass: "lists-item" }, [
                          _vm._v("是否当月生日")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "lists-text" }, [
                          _vm._v(
                            _vm._s(_vm.clientInfo.baseInfo.thisMonthBirthday)
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("div", { staticClass: "lists-item" }, [
                          _vm._v("是否下月生日")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "lists-text" }, [
                          _vm._v(
                            _vm._s(_vm.clientInfo.baseInfo.nextMonthBirthday)
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("div", { staticClass: "lists-item" }, [
                          _vm._v("客户类型")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "lists-text" }, [
                          _vm._v(_vm._s(_vm.clientInfo.baseInfo.cusType))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("div", { staticClass: "lists-item" }, [
                          _vm._v("所属门店")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "lists-text" }, [
                          _vm._v(_vm._s(_vm.clientInfo.baseInfo.createDeptName))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("div", { staticClass: "lists-item" }, [
                          _vm._v("所属店员")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "lists-text" }, [
                          _vm._v(_vm._s(_vm.clientInfo.baseInfo.createUserName))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("div", { staticClass: "lists-item" }, [
                          _vm._v("客户活跃度")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "lists-text" }, [
                          _vm._v(_vm._s(_vm.clientInfo.baseInfo.cusActivity))
                        ])
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.tabActive == 1
                ? _c("div", { staticClass: "information-flex" }, [
                    _c("ul", { staticClass: "lists" }, [
                      _c("li", [
                        _c("div", { staticClass: "lists-item" }, [
                          _vm._v("近12个月购买金额")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "lists-text" }, [
                          _vm._v(
                            _vm._s(_vm.clientInfo.contribution.oneYearAmount)
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("div", { staticClass: "lists-item" }, [
                          _vm._v("累计购买金额")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "lists-text" }, [
                          _vm._v(_vm._s(_vm.clientInfo.contribution.amountSum))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("div", { staticClass: "lists-item" }, [
                          _vm._v("累计购买相机数量")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "lists-text" }, [
                          _vm._v(_vm._s(_vm.clientInfo.contribution.cameraSum))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("div", { staticClass: "lists-item" }, [
                          _vm._v("累计购买镜头数量")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "lists-text" }, [
                          _vm._v(_vm._s(_vm.clientInfo.contribution.shotSum))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("div", { staticClass: "lists-item" }, [
                          _vm._v("平均客单价")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "lists-text" }, [
                          _vm._v(
                            _vm._s(_vm.clientInfo.contribution.avgCusPrice)
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("div", { staticClass: "lists-item" }, [
                          _vm._v("购买相机客单价")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "lists-text" }, [
                          _vm._v(
                            _vm._s(_vm.clientInfo.contribution.cameraCusPrice)
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("div", { staticClass: "lists-item" }, [
                          _vm._v("购买镜头客单价")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "lists-text" }, [
                          _vm._v(
                            _vm._s(_vm.clientInfo.contribution.shotCusPrice)
                          )
                        ])
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.tabActive == 2
                ? _c("div", [
                    _c("div", { staticClass: "information-flex" }, [
                      _c("ul", { staticClass: "lists" }, [
                        _c("li", [
                          _c("div", { staticClass: "lists-item" }, [
                            _vm._v("首次购买时间")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "lists-text" }, [
                            _vm._v(_vm._s(_vm.clientInfo.behaviour.firstBuy))
                          ])
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("div", { staticClass: "lists-item" }, [
                            _vm._v("首次购买门店")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "lists-text" }, [
                            _vm._v(
                              _vm._s(_vm.clientInfo.behaviour.firstBuyShop)
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("div", { staticClass: "lists-item" }, [
                            _vm._v("首次购买金额")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "lists-text" }, [
                            _vm._v(
                              _vm._s(_vm.clientInfo.behaviour.firstBuyAmount)
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("div", { staticClass: "lists-item" }, [
                            _vm._v("首次购买相机型号")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "lists-text" }, [
                            _vm._v(
                              _vm._s(_vm.clientInfo.behaviour.firstBuyCamera)
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("div", { staticClass: "lists-item" }, [
                            _vm._v("最近一次购买时间")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "lists-text" }, [
                            _vm._v(
                              _vm._s(_vm.clientInfo.behaviour.latestBuyTime)
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("div", { staticClass: "lists-item" }, [
                            _vm._v("最近一次购买门店")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "lists-text" }, [
                            _vm._v(
                              _vm._s(_vm.clientInfo.behaviour.latestBuyShop)
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("div", { staticClass: "lists-item" }, [
                            _vm._v("最近一次购买金额")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "lists-text" }, [
                            _vm._v(
                              _vm._s(_vm.clientInfo.behaviour.latestBuyAmount)
                            )
                          ])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("hr", {
                      staticStyle: {
                        background: "#EcEcEc",
                        width: "96%",
                        height: "1px",
                        margin: "0 auto",
                        border: "none"
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "information-flex" }, [
                      _c("ul", { staticClass: "lists" }, [
                        _c("li", [
                          _c("div", { staticClass: "lists-item" }, [
                            _vm._v("最近一次跟进时间")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "lists-text" }, [
                            _vm._v(
                              _vm._s(_vm.clientInfo.behaviour.latestFollowTime)
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("div", { staticClass: "lists-item" }, [
                            _vm._v("最近一次参与活动时间")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "lists-text" }, [
                            _vm._v(
                              _vm._s(
                                _vm.clientInfo.behaviour.latestActivityTime
                              )
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("div", { staticClass: "lists-item" }, [
                            _vm._v("最近一次参与课程时间")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "lists-text" }, [
                            _vm._v(
                              _vm._s(
                                _vm.clientInfo.behaviour.latestDurationTime
                              )
                            )
                          ])
                        ])
                      ])
                    ])
                  ])
                : _vm._e()
            ]
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4ac38129", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ac38129","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/client/childCompoents/tagInfo.vue
// module id = null
// module chunks = 